import { apiPost, apiGet } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const loginAPI = (data) => {
  Hotjar.event('login')
  return apiPost('mgmt/session', data)
}

export const switchAppAPI = (data) => {
  return apiGet('mgmt/session/switch-app', data)
}

export const getCurrentSessionAPI = (headers, data = {}) => {
  return apiGet('mgmt/session', data, headers)
}

export const changeShopAPI = (data) => {
  Hotjar.event('change_shop')
  return apiPost('mgmt/session/shop', data)
}

export const resetPasswordAPI = (data) => {
  Hotjar.event('reset_password')
  return apiPost('mgmt/password/reset', data)
}

export const recoverPasswordAPI = (data) => {
  Hotjar.event('recover_password')
  return apiPost('mgmt/password/update', data)
}

export const renewSessionAPI = (headers = {}) => {
  return apiGet('session/renew', {}, headers)
}

export const reviewCompanyAgreementAPI = (email, password) => {
  Hotjar.event('review_company_agreement')
  return apiPost(`mgmt/session/reviewCompanyAgreement`, { email, password })
}



// WEBPACK FOOTER //
// ./src/api/auth.js